import axios from 'axios';
import { API_URL } from 'configs'

export const AI_COMPARISON_LIST_REQUEST = 'AI_COMPARISON_LIST_REQUEST'
export const AI_COMPARISON_LIST_SUCCESS = 'AI_COMPARISON_LIST_SUCCESS'
export const AI_COMPARISON_LIST_VALIDATION_ERROR = 'AI_COMPARISON_LIST_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_AI_COMPARISON_LIST_FEILD_VALIDATION_ERROR = "HIDE_AI_COMPARISON_LIST_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_AI_COMPARISON_LIST_LIST = 'REDIRECT_TO_AI_COMPARISON_LIST_LIST'
export const AI_COMPARISON_LIST_GET_SUCCESS = 'AI_COMPARISON_LIST_GET_SUCCESS'
export const AI_COMPARISON_LIST_SERVER_SUCCESS = 'AI_COMPARISON_LIST_SERVER_SUCCESS'
export const AI_COMPARISON_LIST_DROPDOWN_SUCCESS = 'AI_COMPARISON_LIST_DROPDOWN_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const aiComparisonListRequest = () => ({
  type: AI_COMPARISON_LIST_REQUEST,
})

export const aiComparisonListServerListSuccess = () => ({
  type: AI_COMPARISON_LIST_SERVER_SUCCESS
})

const aiComparisonListListSuccess = aiComparisonListList => ({
  type: AI_COMPARISON_LIST_SUCCESS,
  aiComparisonListList: aiComparisonListList,
})

const aiComparisonListFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: AI_COMPARISON_LIST_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const aiComparisonListAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(aiComparisonListSuccessNotification(message))
  dispatch(redirectToAIComparisonListList())
}

export const redirectToAIComparisonListList = () => ({
  type: REDIRECT_TO_AI_COMPARISON_LIST_LIST,
})

const getAIComparisonListSuccess = (response, action) => ({
  type: AI_COMPARISON_LIST_GET_SUCCESS,
  record: response,
  actionType: action
})

const aiComparisonListSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideAIComparisonListValidationError = (feild_key) => ({
  type: HIDE_AI_COMPARISON_LIST_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

/*
* AI Comparison List dropdown list fetch methods
*/
const aiComparisonListDropdownSuccess = aiComparisonDropdownList => ({
  type: AI_COMPARISON_LIST_DROPDOWN_SUCCESS,
  aiComparisonDropdownList: aiComparisonDropdownList,
})

export const aiComparisonListDropdownFetch = (client_ids, object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/getAIComparisonListForDropdown", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        client_ids: client_ids,
        object_viewed_id: object_viewed_id
      }
    })
    .then((response) => {
      dispatch(aiComparisonListDropdownSuccess(response.data))
      dispatch(hideCommonLoader())
    }, (error) => {
      handleErrorResponse(error, dispatch)
      dispatch(hideCommonLoader())
    });

  }
}

export const aiComparisonListListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(aiComparisonListListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addAIComparisonList = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        aiComparisonListAddUpadteSuccess('AI Comparison List Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateAIComparisonList = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        aiComparisonListAddUpadteSuccess('AI Comparison List Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getAIComparisonListById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getAIComparisonListSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const deleteAIComparisonList = (aiComparisonListId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonListRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonList/delete/" + aiComparisonListId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(aiComparisonListSuccessNotification('AI Comparison List deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}


// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(aiComparisonListFailure(err))
    }
  }
  catch (e) {
    dispatch(aiComparisonListFailure('Unable to perform action.Something went wrong'))
  }
}   